import { render } from "./SelectCustomer.vue?vue&type=template&id=8c0470f6&scoped=true"
import script from "./SelectCustomer.vue?vue&type=script&lang=js"
export * from "./SelectCustomer.vue?vue&type=script&lang=js"

import "./SelectCustomer.vue?vue&type=style&index=0&id=8c0470f6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0470f6"]])

export default __exports__